// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TableSegments {
  min-height: 350px;
}`, "",{"version":3,"sources":["webpack://./src/vibeguide/src/components/VibeTable/Tables/TableSegments.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF","sourcesContent":[".TableSegments {\n  min-height: 350px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
